<ng-container *ngIf="combinedBrowseLinks$ | async as links">
  <section class="provider-container" *ngIf="
      links.specialities?.length ||
      links.insurances?.length ||
      links.treatmentPreferences?.length ||
      links.cities?.length
    " aria-labelledby="provider-title">
    <div class="provider-title">
      <h4 id="provider-title">
        Find a provider{{ currentStateName ? ` in ${currentStateName}` : '' }} that <em class="italic-text">meets your
          needs</em>
      </h4>
      <p>
        Finding the right therapist takes time. Browse more options to find someone who truly fits your needs.
      </p>
    </div>

    <div class="provider-content" role="main">
      <!-- Specialties section -->
      <ng-container *ngTemplateOutlet="searchSectionTemplate; context: {
        title: 'Search by Specialty',
        headingId: 'specialty-heading',
        items: links.specialities,
        itemUriPrefix: uriPrefix.SPECIALTY,
        ariaLabelPrefix: 'Search for',
        includeCity: true
      }"></ng-container>

      <!-- Insurance section -->
      <ng-container *ngTemplateOutlet="searchSectionTemplate; context: {
        title: 'Search by Insurance',
        headingId: 'insurance-heading',
        items: links.insurances,
        itemUriPrefix: uriPrefix.INSURANCE,
        ariaLabelPrefix: 'Search for providers accepting',
        includeCity: true
      }"></ng-container>

      <!-- Treatment preferences section -->
      <ng-container *ngTemplateOutlet="searchSectionTemplate; context: {
        title: 'Search by Treatment Approaches',
        headingId: 'treatment-heading',
        items: links.treatmentPreferences,
        itemUriPrefix: uriPrefix.TREATMENT_PREFERENCE,
        ariaLabelPrefix: 'Search for providers who offer',
        includeCity: true
      }"></ng-container>

      <!-- Cities section -->
      <ng-container *ngTemplateOutlet="searchSectionTemplate; context: {
        title: 'Search by City',
        headingId: 'city-heading',
        items: links.cities,
        itemUriPrefix: uriPrefix.CITY,
        ariaLabelPrefix: 'Search for providers in',
        includeCity: false
      }"></ng-container>
    </div>

    <div class="show-more-container" *ngIf="hasMore$ | async">
      <a (click)="toggleShowAll()" class="search-link">
        {{ (showAll$ | async) ? 'Show less' : 'Show more' }}
      </a>
    </div>
  </section>

  <!-- Template for search sections -->
  <ng-template #searchSectionTemplate let-title="title" let-headingId="headingId" let-items="items"
    let-itemUriPrefix="itemUriPrefix" let-ariaLabelPrefix="ariaLabelPrefix" let-includeCity="includeCity">
    <section class="search-by-type" *ngIf="items?.length > 0" [attr.aria-labelledby]="headingId">
      <h6 [id]="headingId">{{ title }}</h6>
      <ng-container *ngFor="let item of items">
        <a class="search-link" [href]="
          providerDirectoryUrl +
          '/' +
          uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
          '/' +
          (includeCity ? uriPrefix.CITY + '-' + ((uriSafeCity$ | async) || emptyURIValue) + '/' : '') +
          itemUriPrefix + '-' + item.uriSafeValue
          " target="_blank" rel="noopener noreferrer" [attr.aria-label]="ariaLabelPrefix + ' ' + item.value">
          {{ item.value }}
        </a>
      </ng-container>
    </section>
  </ng-template>
</ng-container>